import React from 'react';
import { useFederalStates } from '../../Aemter/hooks';
import { LoadingSpinner } from '../../core/LoadingSpinner';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useGetFederalStateLogins } from '../../hooks/reactQuerys/FederalStateLoginQueries';
import { FederalStateRow } from './FederalStateRow';
import { useGetUsers } from '../../hooks/data';
import { useGetUserGroups } from '../../hooks/reactQuerys/UserQueries';

export const LandregisterSettingOverview: React.FC = () => {
  const { federalStates, isLoadingFederalStates } = useFederalStates();
  const {
    federalStateLogins,
    isFederalStateLogins,
    refetchFederalStateLogins,
  } = useGetFederalStateLogins();
  const { users, isLoadingUsers } = useGetUsers();
  // userGroups werden nur im Bearbeiten-Dialog (Mehrfachauswahl) benötigt.
  // Die Übersicht NICHT darauf warten lassen, sonst blockiert eine langsame/
  // hängende /usergroup-Query die ganze Seite.
  const { userGroups } = useGetUserGroups();

  if (isLoadingFederalStates || isFederalStateLogins || isLoadingUsers) {
    return <LoadingSpinner />;
  }

  if (!federalStates || !federalStateLogins || !users) {
    return (
      <Box sx={{ m: 2 }}>
        <Typography>
          Ein Fehler ist aufgetreten! Bitte versuchen Sie es später erneut.
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Typography variant='h5'>Grundbuchanbindung</Typography>

      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Bundesland</TableCell>
            <TableCell>Unterstützt</TableCell>
            <TableCell>Zugänge</TableCell>
            <TableCell>Aktionen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {federalStates.map(federalstate => (
            <FederalStateRow
              key={`idFedearalState-${federalstate.idFederalState}`}
              federalState={federalstate}
              federalStateLogins={federalStateLogins}
              federalStates={federalStates}
              users={users}
              userGroups={userGroups ?? []}
              refetchFederalStateLogins={refetchFederalStateLogins}
            />
          ))}
        </TableBody>
      </Table>
    </>
  );
};
